import {
  CarRentalSearchBarActions,
  CarRentalSearchBarActionType,
} from './actions';
import { ICarRentalSearchBarState } from './state';

const CarRentalSearchBarReducer = (
  state: ICarRentalSearchBarState,
  action: CarRentalSearchBarActions
): ICarRentalSearchBarState => {
  const { type, payload } = action;

  switch (type) {
    case CarRentalSearchBarActionType.SET_DEPERATURE:
      return {
        ...state,
        departure: payload,
      };

    case CarRentalSearchBarActionType.SET_ARRIVAL:
      return {
        ...state,
        arrival: payload,
      };
    case CarRentalSearchBarActionType.SET_PICK_UP_DATE:
      return {
        ...state,
        pickUpDate: payload,
      };
    case CarRentalSearchBarActionType.SET_DROP_UP_DATE:
      return {
        ...state,
        dropUpDate: payload,
      };
    case CarRentalSearchBarActionType.SET_DROP_UP_TIME:
      return {
        ...state,
        dropUpTime: payload,
      };
    case CarRentalSearchBarActionType.SET_PICK_UP_TIME:
      return {
        ...state,
        pickUpTime: payload,
      };
    case CarRentalSearchBarActionType.SET_IS_DIFFERENT_LOCATION:
      return {
        ...state,
        isDifferentLocation: payload,
      };
  }
};
export default CarRentalSearchBarReducer;
